import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_FAMCOMPTA_SCHEMA_LITERAL = {
    title: 'Schéma FamComptas',
    description: 'Décrit le paramètrage des taxes',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        FA_CODEFAMILLE: { type: 'string' },
        N_CATCOMPTA: { type: 'number' },

        DL_CODETAXE1: { type: 'string' },
        DL_LIBTAXE1: { type: 'string' },
        DL_TAXE1: { type: 'number' },
        DL_TYPETAXE1: { type: 'number' },
        DL_TYPETAUX1: { type: 'number' },

        DL_CODETAXE2: { type: 'string' },
        DL_LIBTAXE2: { type: 'string' },
        DL_TAXE2: { type: 'number' },
        DL_TYPETAXE2: { type: 'number' },
        DL_TYPETAUX2: { type: 'number' },

        DL_CODETAXE3: { type: 'string' },
        DL_LIBTAXE3: { type: 'string' },
        DL_TAXE3: { type: 'number' },
        DL_TYPETAXE3: { type: 'number' },
        DL_TYPETAUX3: { type: 'number' }
    },
    required: [ 'CBMARQ', 'FA_CODEFAMILLE', 'N_CATCOMPTA' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_FAMCOMPTA_SCHEMA_LITERAL);
export type RxFFamComptaDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_FAMCOMPTA_SCHEMA: RxJsonSchema<RxFFamComptaDocumentType> = F_FAMCOMPTA_SCHEMA_LITERAL;
